import { BrowserRouter, Routes, Route, Navigate } from 'react-router'
import Nav from './components/Nav'
import Ticker from './components/Ticker'
import Footer from './components/Footer'
import Kaufplan from './pages/Kaufplan'
import Einstiege from './pages/Einstiege'
import Makro from './pages/Makro'
import Archiv from './pages/Archiv'
import Giganten2026 from './pages/reports/Giganten2026'
import Geopolitik2026 from './pages/reports/Geopolitik2026'

export default function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Ticker />
      <Routes>
        <Route path="/"           element={<Kaufplan />}       />
        <Route path="/einstiege"  element={<Einstiege />}      />
        <Route path="/makro"      element={<Makro />}          />
        <Route path="/archiv"     element={<Archiv />}         />
        <Route path="/giganten"   element={<Giganten2026 />}   />
        <Route path="/geopolitik" element={<Geopolitik2026 />} />
        {/* Alte Seiten (Empfehlungen, Chancen, ETFs …) wurden zusammengelegt */}
        <Route path="/etfs"         element={<Navigate to="/einstiege" replace />} />
        <Route path="/empfehlungen" element={<Navigate to="/einstiege" replace />} />
        <Route path="/chancen"      element={<Navigate to="/einstiege" replace />} />
        <Route path="*"             element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}
